import * as yup from 'yup';
import UserPresenter from 'presenters/UserPresenter';

const validationFields = {
  firstMessage: yup.string().max(250, 'validations.loanOfficerAutoFollowupsMessageesForm.firstMessage.maxLength'),
  secondMessage: yup.string().max(250, 'validations.loanOfficerAutoFollowupsMessageesForm.secondMessage.maxLength'),
  thirdMessage: yup.string().max(250, 'validations.loanOfficerAutoFollowupsMessageesForm.thirdMessage.maxLength'),
};

export const getDefaultAttributes = user => {
  return {
    firstMessage: UserPresenter.autoFollowupsMessageText(user, 1) || '',
    secondMessage: UserPresenter.autoFollowupsMessageText(user, 2) || '',
    thirdMessage: UserPresenter.autoFollowupsMessageText(user, 3) || '',
  };
};

export default yup.object().shape({ ...validationFields });



// WEBPACK FOOTER //
// ./src/forms/loanOfficerAutoFollowupsMessagesForm.js